"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = edit;
exports.getKittenSortList = getKittenSortList;

var _request = _interopRequireDefault(require("@/utils/request"));

function edit(data) {
  return (0, _request.default)({
    url: 'set-kitten-sort-list',
    method: 'post',
    data: data
  });
}

function getKittenSortList(params) {
  return (0, _request.default)({
    url: 'get-kitten-sort-list',
    method: 'get',
    params: params
  });
}